module.exports = __webpack_public_path__ + "static/media/hud_testtube_marker.ddc8e8e8.svg";